import { render } from "./UserProgress.vue?vue&type=template&id=a6f06f4a"
import script from "./UserProgress.vue?vue&type=script&lang=js"
export * from "./UserProgress.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__